import React, {ReactNode} from "react";
import {Container, Divider, Text} from "../../../../ui";
import {IconArrowDownGrey} from "../../../bounce-ui";

interface ISection {
  title: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  children: ReactNode;
}

export const DetailsSection = ({title, isOpen, setIsOpen, children}: ISection) => {
  return (
    <>
      <Divider fullWidth />
      <Container fullWidth row onClick={() => setIsOpen(!isOpen)} sx={{justifyContent: "space-between"}}>
        <Text size={12} fontWeight={"medium"} sx={{textTransform: "uppercase"}}>
          {title}
        </Text>
        <IconArrowDownGrey style={{...(isOpen && {transform: "rotate(180deg)"})}} />
      </Container>
      {isOpen && children}
    </>
  );
};
